import { Account } from '@commutifi-fe/interfaces';
import { Countries } from '@commutifi/constants/Countries';
import { CountryCode, parsePhoneNumber } from 'utils/phoneNumber';
import { ExtendedAccount } from 'shared/interfaces';
import { logger } from '@commutifi-fe/logger';
export const expandAccountPhoneNumber = (phoneNumber: string | null | undefined, country: Countries | undefined) => {
  try {
    if (!phoneNumber) {
      return undefined;
    }
    return parsePhoneNumber(phoneNumber, (country || 'US') as CountryCode);
  } catch {
    // Since we didn't always had a standard format to save phone numbers and we can't always
    // guarantee the format will be valid we simply print a warning and avoid any crash
    logger.warning(`Couldn't parse the phone number with libphonenumber-js: ${phoneNumber}`);
  }
  return undefined;
};
export const splitAccountName = (name: string | null | undefined) => {
  if (!name) {
    return [];
  }
  const nameParts = name.split(' ');
  return [nameParts?.[0], nameParts?.splice(1).join(' ')];
};
export const extendAccountWithFullNameAndPhoneNumber = (account: Account): ExtendedAccount => {
  const [firstName, lastName] = splitAccountName(account.name);
  return {
    ...account,
    firstName,
    lastName,
    phoneNumber: expandAccountPhoneNumber(account.phoneNumber, account.country)
  };
};